export const GET_PRODUCTS = '@services/GET_PRODUCTS';
export const GET_PRODUCT = '@services/GET_PRODUCT';
export const FILTER_PRODUCTS = '@services/FILTER_PRODUCTS';
export const GET_ADDRESSES = '@services/GET_ADDRESSES';

import { axiosPlainApi, axiosApiInstance } from 'helpers/api';

export const getProducts = () => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            return axiosApiInstance.post('/api/selfservice/products', state).then((response) => {
                dispatch({
                    type: GET_PRODUCTS,
                    products: response.data
                });
            });
        } else return null;
    };
};

export const getProduct = (id) => {
    return (dispatch, getState) => {
        const state = getState();
        if (state) {
            return axiosApiInstance.post('/api/selfservice/products/' + id, state).then((response) => {
                dispatch({
                    type: GET_PRODUCT,
                    products: response.data
                });
            });
        } else return null;
    };
};

export function filterProducts(filter) {
    return async (dispatch) => {
        try {
            //const response = await axios.post('/api/products/filter', { filter });
            //dispatch(slice.actions.filterProductsSuccess(response.data));
            return axiosApiInstance.post('/api/selfservice/products', filter).then((response) => {
                dispatch({
                    type: FILTER_PRODUCTS,
                    products: response.data
                });
            });
        } catch (error) {
            //dispatch(slice.actions.hasError(error));
        }
    };
}

export const getAddresses = () => {
    return async (dispatch) => {
        try {
            //const response = await axios.post('/api/products/filter', { filter });
            //dispatch(slice.actions.filterProductsSuccess(response.data));
            /*
            return axiosPlainApi.post('/api/selfservice/products', filter).then((response) => {
                dispatch({
                    type: FILTER_PRODUCTS,
                    products: response.data
                });
            });
            */
            dispatch({
                type: GET_ADDRESSES,
                payload: 'Adrese '
            });
        } catch (error) {
            //dispatch(slice.actions.hasError(error));
        }
    };
};

export const editAddress = () => {
    return null;
};

export const addAddress = () => {
    return null;
};
